import { emptyObject } from '@constants/empty';
import { getMeUsername } from './auth';

export const getUsers = (state) => state.users;

export const getUser = (state, username) =>
  state.users.data[username] || emptyObject;

export const getFeedbackOptions = ({ users }) => users?.feedbackOptions;

export const getPlatinumEducator = (state) =>
  getUser(state, getMeUsername(state)?.toLowerCase?.()).isPlatinumEducator;

export const getPlatformEducator = (state) =>
  getUser(state, getMeUsername(state)?.toLowerCase?.()).isPlatformEducator;

export const getSubscriptionFeedbackCards = ({ users }) =>
  users?.subscriptionFeedbackCards;
